/** Kontakt kluba — jedno mesto za broj telefona i WhatsApp. */
export const PHONE_DISPLAY = '+381 63 113 4892';
export const PHONE_TEL = '+381631134892';
/** Broj u međunarodnom formatu bez + i razmaka, kako ga traži wa.me */
export const WHATSAPP_NUMBER = '381631134892';

export const whatsappLink = (message?: string): string =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
